import React, { ReactElement, useEffect, useState } from 'react';
import {
  SearchIconContainer,
  SearchInputContainer,
  StyledSearchInput,
} from './styled';
import Lang from '@lang/en';
import { SearchIconWhite } from '@root/src/assets/images';

interface PropsI {
  handleSearchChange: (value: string) => void;
  debounceTimeout?: number;
  defaultValue?: string;
  fixedWidth?: number;
}

const defaultDebounceTimeout = 1000;

const SearchInput = ({
  handleSearchChange,
  debounceTimeout = defaultDebounceTimeout,
  defaultValue,
  fixedWidth,
}: PropsI): ReactElement => {
  const [timeoutId, setTimeoutId] = useState<Timeout | null>(null);

  useEffect(() => {
    return (): void => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutId]);

  const handleOnChange = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>): void => {
    const id = setTimeout(() => {
      handleSearchChange(value);
    }, debounceTimeout);
    setTimeoutId(id);
  };

  return (
    <SearchInputContainer fixedWidth={fixedWidth}>
      <StyledSearchInput
        placeholder={Lang.searchText}
        onChange={handleOnChange}
        defaultValue={defaultValue}
        data-testid="searchInput"
        maxLength={32}
      />
      <SearchIconContainer>
        <SearchIconWhite />
      </SearchIconContainer>
    </SearchInputContainer>
  );
};

export default SearchInput;
